import { useCallback, useMemo } from "react";
import { GridPaginationModel } from "@mui/x-data-grid";
import { useURLSearchParams } from "./useURLSearchParams";

interface UsePaginatedDataGridOptions {
  defaultPage?: number;
  defaultPageSize?: number;
}

export const usePaginatedDataGrid = (options: UsePaginatedDataGridOptions = {}) => {
  const { defaultPage = 0, defaultPageSize = 10 } = options;
  const { urlParams, updateSearchParams } = useURLSearchParams();

  const paginationModel = useMemo<GridPaginationModel>(
    () => ({
      page: Number(urlParams.page) || defaultPage,
      pageSize: Number(urlParams.size) || defaultPageSize
    }),
    [urlParams, defaultPage, defaultPageSize]
  );

  const handlePaginationModelChange = useCallback(
    (model: GridPaginationModel) => {
      const updates: Record<string, any> = {};

      if (model.page !== paginationModel.page) {
        updates.page = model.page;
      }

      if (model.pageSize !== paginationModel.pageSize) {
        updates.size = model.pageSize;
        updates.page = 0; // ページサイズ変更時は1ページ目に戻る
      }

      if (Object.keys(updates).length > 0) {
        updateSearchParams(updates);
      }
    },
    [paginationModel, updateSearchParams]
  );

  return {
    paginationModel,
    handlePaginationModelChange
  };
};
